import { Badge } from "@/components/ui/badge";
import { useLang } from "@/context/LanguageContext";

export function PrioriteBadge({ value }) {
  const { t } = useLang();
  const map = {
    normal: "bg-blue-50 text-blue-700 border-blue-200",
    urgent: "bg-amber-50 text-amber-800 border-amber-200",
    stat: "bg-red-50 text-red-800 border-red-200",
  };
  return (
    <Badge variant="outline" className={`${map[value] || ""} font-medium`} data-testid={`priorite-${value}`}>
      {t(`priorite_${value}`)}
    </Badge>
  );
}

export function StatutBadge({ value }) {
  const { t } = useLang();
  const map = {
    recue: "bg-slate-100 text-slate-700 border-slate-200",
    macroscopie: "bg-sky-50 text-sky-700 border-sky-200",
    inclusion: "bg-sky-50 text-sky-700 border-sky-200",
    coupe: "bg-sky-50 text-sky-700 border-sky-200",
    coloration: "bg-indigo-50 text-indigo-700 border-indigo-200",
    ihc: "bg-violet-50 text-violet-700 border-violet-200",
    moleculaire: "bg-violet-50 text-violet-700 border-violet-200",
    lecture: "bg-amber-50 text-amber-800 border-amber-200",
    redige: "bg-teal-50 text-teal-700 border-teal-200",
    valide: "bg-emerald-50 text-emerald-700 border-emerald-200",
    transmis: "bg-emerald-50 text-emerald-700 border-emerald-200",
    archive: "bg-slate-100 text-slate-500 border-slate-200",
  };
  return (
    <Badge variant="outline" className={`${map[value] || "bg-slate-50 text-slate-600 border-slate-200"}`}>
      {t(`statut_${value}`)}
    </Badge>
  );
}

export function DelaiBadge({ value, cible }) {
  const { t } = useLang();
  if (!value) return null;
  const map = {
    a_temps: "bg-emerald-50 text-emerald-700 border-emerald-200",
    bientot: "bg-amber-50 text-amber-800 border-amber-200",
    retard: "bg-red-50 text-red-800 border-red-200",
    termine: "bg-slate-100 text-slate-600 border-slate-200",
  };
  return (
    <Badge variant="outline" className={`${map[value] || ""} font-medium`} data-testid={`delai-${value}`}>
      {t(`delai_${value}`)}{cible ? ` · ${cible}` : ""}
    </Badge>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="font-head text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex gap-2">{children}</div>
    </div>
  );
}
